/**
 * Maps sidebar labels to backend plan module keys (first URL segment).
 * Grievance, AI Copilot, Integration, Settings, and Help are not plan-gated.
 */

const MODULE_ALIASES = {
  roster: "rostering",
};

export const NAV_LABEL_TO_PLAN_MODULE = {
  Home: "home",
  Dashboard: "home",
  Administrator: "administrator",
  Master: "master",
  Configuration: "configuration",
  Employee: "employee",
  Payroll: "payroll",
  Attendance: "attendance",
  "Asset Management": "asset_management",
  Roster: "rostering",
  Appraisal: "appraisal",
  Training: "training",
  "Data Migration": "data_migration",
  Reports: "reports",
};

/** Always visible regardless of plan tier. */
export const PLAN_UNGATED_NAV_LABELS = new Set([
  "Grievance",
  "Settings",
  "Integration",
  "IT Help Desk",
  "AI Copilot",
]);

export function normalizePlanModule(module) {
  if (!module) return module;
  const key = String(module).trim().toLowerCase();
  return MODULE_ALIASES[key] || key;
}

export function buildAllowedPlanModuleSet(planModules) {
  if (!Array.isArray(planModules) || planModules.length === 0) {
    return null;
  }
  const allowed = new Set();
  planModules.forEach((module) => {
    allowed.add(normalizePlanModule(module));
  });
  return allowed;
}

export function getSessionPlanModules() {
  try {
    const raw =
      sessionStorage.getItem("modules") || localStorage.getItem("modules");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function filterNavByPlanModules(navItems, planModules) {
  const allowed = buildAllowedPlanModuleSet(planModules);
  if (!allowed) return navItems;

  return navItems.filter((item) => {
    if (!item?.label || PLAN_UNGATED_NAV_LABELS.has(item.label)) {
      return true;
    }
    const moduleKey = NAV_LABEL_TO_PLAN_MODULE[item.label];
    if (!moduleKey) {
      return true;
    }
    return allowed.has(normalizePlanModule(moduleKey));
  });
}
